<div class="gateway">
  <div class="gateway__header">
    <h1 class="gateway__title">Gateway Data</h1>
    <button type="button" class="gateway__close" aria-label="Close" (click)="closeModal()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  @if (dataModel === 'model1') {
    @if (hasSearchFields) {
    <div class="gateway__query-section">
      <div class="gateway__query-header">
        <h5 class="gateway__query-title">Attribute query</h5>
        <p class="gateway__query-desc">
          Enter {{ searchFieldsHint }} to fetch entity data
        </p>
      </div>
      <div class="gateway__query-inputs">
        @for (field of searchFields; track field) {
          <div class="gateway__field">
            <label [for]="'gateway-' + field" class="gateway__label">{{ fieldLabel(field) }}</label>
            <input
              type="text"
              [id]="'gateway-' + field"
              [name]="field"
              class="gateway__input"
              [placeholder]="fieldPlaceholder(field)"
              [attr.inputmode]="isPhoneField(field) ? 'numeric' : null"
              [attr.maxlength]="isPhoneField(field) ? 10 : null"
              [attr.pattern]="isPhoneField(field) ? '[0-9]{10}' : null"
              [attr.autocomplete]="isPhoneField(field) ? 'tel' : null"
              [(ngModel)]="queryValues[field]"
              (input)="onFieldInput(field, $event)"
            />
            @if (isPhoneField(field) && queryValues[field] && queryValues[field].length < 10) {
              <span class="gateway__field-hint">Enter a 10-digit phone number</span>
            }
          </div>
        }
        <div class="gateway__actions">
          <button
            type="button"
            class="gateway__search-btn"
            (click)="searchAttributeData()"
            [disabled]="isAttributeSearchDisabled"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
            Search
          </button>
          <button
            type="button"
            class="gateway__reset-btn"
            (click)="resetAttributeQuery()"
            [disabled]="isLoading"
            title="Reset"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
            Reset
          </button>
        </div>
      </div>
    </div>
    }

    @if (isLoading) {
      <div class="gateway__loading">
        <div class="gateway__spinner" role="status" aria-live="polite"></div>
        <p class="gateway__loading-text">Fetching entity data…</p>
      </div>
    }

    @if (errorMessage && !isLoading) {
      <div class="gateway__error">
        <div class="gateway__error-alert">{{ errorMessage }}</div>
      </div>
    }

    @if (!isLoading && !errorMessage && allData.length > 0) {
      <div class="gateway__info">
        <span class="gateway__info-text">Showing all {{ allData.length }} entries</span>
        <button type="button" class="gateway__download-btn" (click)="downloadAllData()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download
        </button>
      </div>
      <div class="gateway__body">
        <code class="gateway__code">{{ displayData }}</code>
      </div>
    }
  }

  @if (dataModel === 'model2') {
    <div class="gateway__query-section">
      <div class="gateway__query-header">
        <h5 class="gateway__query-title">Temporal query</h5>
        <p class="gateway__query-desc">Select a date range to fetch temporal data</p>
      </div>
      <div class="gateway__query-inputs">
        <div class="gateway__field">
          <label for="startDate" class="gateway__label">Start date</label>
          <input type="date" id="startDate" class="gateway__input" [(ngModel)]="startDate" [max]="maxDateStr" [min]="minDateStr" />
        </div>
        <div class="gateway__field">
          <label for="endDate" class="gateway__label">End date</label>
          <input type="date" id="endDate" class="gateway__input" [(ngModel)]="endDate" [max]="maxDateStr" [min]="minDateStr" />
        </div>
        <div class="gateway__actions">
          <button type="button" class="gateway__search-btn" (click)="searchTemporalData()" [disabled]="!startDate || !endDate || isLoading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
            Search
          </button>
          <button type="button" class="gateway__reset-btn" (click)="resetDates()" [disabled]="(!startDate && !endDate) || isLoading" title="Reset dates">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
            Reset
          </button>
        </div>
      </div>
    </div>

    @if (isLoading) {
      <div class="gateway__loading">
        <div class="gateway__spinner" role="status"></div>
        <p class="gateway__loading-text">Fetching temporal data…</p>
      </div>
    }

    @if (errorMessage && !isLoading) {
      <div class="gateway__error">
        <div class="gateway__error-alert">{{ errorMessage }}</div>
      </div>
    }

    @if (!isLoading && !errorMessage && allData.length > 0) {
      <div class="gateway__info">
        <span class="gateway__info-text">Showing all {{ allData.length }} entries</span>
        <button type="button" class="gateway__download-btn" (click)="downloadAllData()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download
        </button>
      </div>
      <div class="gateway__body">
        <code class="gateway__code">{{ displayData }}</code>
      </div>
    }
  }
</div>
